export const BooleanWithTypeGuard = <T>(value: T | undefined | null): value is T =>
  value !== undefined && value !== null ? Boolean(value) : false;
